import { createTheme } from '@mui/material/styles';

export const theme = createTheme({
  shape: {
    borderRadius: 8,
  },
  palette: {
    primary: {
      main: '#941d55',
    },
    secondary: {
      main: '#edf2ff',
    },
  },
});
